import axiosInstance from "../axiosInstance";

export const usersApi = {
  post: (path, params, headers, cancelToken) =>
    axiosInstance
      .post(`/Users${path}`, params, {
        cancelToken: cancelToken?.token,
        headers,
      })
      .then((res) => {
        console.log(res);
        if (res?.data?.error) throw res.data;
        return res?.data;
        // if (res?.data?.error || res?.data?.status === 'error') throw res.data;
      })
      .catch((err) => {
        throw err.error ? err : err?.response?.data;
      }),
  get: (path, params, headers, cancelToken) =>
    axiosInstance
      .get(
        `/Users${path}`,
        { params },
        {
          cancelToken: cancelToken?.token,
          headers,
        }
      )
      .then((res) => {
        if (res?.data?.error) throw res.data;
        return res?.data;
      })
      .catch((err) => {
        throw err.error ? err : err?.response?.data;
      }),
};

export const getUsers = async (params) => usersApi.get("/GetUsers", params);

export const createUser = async (params) =>
  usersApi.post("/Create", JSON.stringify(params), {
    "Content-Type": "application/json",
  });

export const updateUser = async (params) =>
  usersApi.post("/Update", JSON.stringify(params), {
    "Content-Type": "application/json",
  });

export const getUser = async (id) => usersApi.get(`/GetUser/${id}`);

export const resendInvitation = async (id) =>
  usersApi.get(`/ResendInvitation/${id}`);

export const getInvitationInfo = async (id, token) => {
  return axiosInstance
    .get(`/Users/GetInvitationInfo?id=${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
    .then((res) => {
      if (res?.data?.error) throw res.data;
      return res?.data;
    })
    .catch((err) => {
      throw err.error ? err : err?.response?.data;
    });
};

export const activateAccount = async (params) =>
  usersApi.post("/activate", params);

export const changePassword = async (params) =>
  usersApi.post("/changePassword", params);

export const resetPassword = async (params) =>
  usersApi.post("/resetPassword", params);

export const changeEmail = async (params) =>
  usersApi.post('/changeEmail', params)

export const verifyEmail = async (params) =>
  usersApi.post('/verifyEmail', params)

// export const getInspection = async (params) =>
//     usersApi.get("/GetInspection", params);

